import { Constant } from "./constant";

class FunctionAppEndpoint {
    public static ValidateSSOToken = `/api/validatessotoken`
}

export default FunctionAppEndpoint;